module.exports = __webpack_public_path__ + "static/media/top-bar-collect-disabled.14cf9090.png";